import React from "react"

import { ProjectPageFloorSidebar } from "./ProjectPageFloorSidebar"
import {
  UseProjectPageFloorSidebarModelArgs,
  useProjectPageFloorSidebarModel
} from "./hooks/useProjectPageFloorSidebarModel"

export const ProjectPageFloorSidebarConnector = React.memo(
  (props: UseProjectPageFloorSidebarModelArgs) => (
    <ProjectPageFloorSidebar
      autoFocus
      id="project-page-floor-sidebar"
      {...useProjectPageFloorSidebarModel(props)}
    />
  )
)
